export default "/images/brand3.png?198dba25304cd51b47dfea7909263c64";